// TODO: Typecheck key and namespace value
// Annotate translation keys for extraction

import type { Namespace, ParseKeys } from 'i18next'

// useTranslation('purchase-form')
export const tKey = <ns extends Namespace>(key: ParseKeys<ns>) => key

// Make sure scanner puts translations in proper  namespaces
export const setI18nNamespace = (_ns: string) => {}
